import React from 'react'

import './key-value-table.scss'

export default class KeyValueTable extends React.Component {
  render() {
    const { data = {}, propertiesToShow = [], className = '' } = this.props

    return (
      <table className={`key-value-list ${className}`}>
        <tbody>
          {propertiesToShow.map((property, index) => {
            if (property.key === 'separator') {
              return (
                <tr key={`separator-${index}`} className="separator">
                  <td colSpan={2}>
                    <div className="horiz-line" />
                  </td>
                </tr>
              )
            }

            const value = React.isValidElement(property.renderer)? property.renderer
              : property.renderer? property.renderer(data[property.key])
              : data[property.key]

            return (
              <tr key={`${index}-${property.key}`}>
                <td>
                  <strong className="key-value-list__key">
                    {property.title || property.key}:{' '}
                  </strong>
                </td>

                <td>{value || '-'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DataPresenters/keyValueTable.js